import React, { useState } from 'react';
import IdentityVerification from "../IdentityVerification";

function KYCVerification() {
    const [showIframe, setShowIframe] = useState(false);

    const handleStartKYC = () => {
        setShowIframe(true);
    };

    return (
         <IdentityVerification />
    );
}

export default KYCVerification;

